<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.extr_cd_codigo }} - {{ $t('name') }} :
								{{ item.extr_nm_nome }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVColetor()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<InputText
					v-model="model.extr_nm_nome"
					:label="$t('name')"
				/>
				<InputText
					v-model="model.extr_tx_senha_app"
					:label="$t('password')"
					@input="validaPassword"
				/>
				<p
					v-if="mensagemErro"
					style="color: red"
				>
					{{ mensagemErro }}
				</p>
				<Switcher
					v-model="model.extr_is_bloqueado"
					style="margin-top: 1rem"
					:label="$t('blockUser')"
				/>
				<p v-if="model.extr_is_bloqueado">
					{{ $t('helpBlockUser') }}
				</p>

				<Accordion :label="$t('optionalFields')">
					<InputText
						v-model="model.extr_tx_telefone"
						v-mask="'(##)-#####-####'"
						:label="$t('phone')"
					/>

					<InputText
						v-model="model.extr_tx_funcao"
						:label="$t('function')"
					/>
				</Accordion>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Accordion from '../../../components/Accordion/Accordion'
import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'
import Switcher from '../../../components/Switcher/Switcher'
import { TheMask } from 'vue-the-mask'
import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	createExecutor,
	deleteExecutorByIdList,
	getAllExecutores,
	updateExecutor,
} from '../../../services/requests/ExecutorRequests'

import { abreviar, desabreviar } from '../../../constants/Abreviacoes/UsuariosBloqueado'

import { classesParaUsuariosBloqueados } from '../../../constants/Tags/Tags'

import download from 'downloadjs'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Accordion,
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		Switcher,
		KebabMenu,
		ExclusionAlert,
	},
	directives: {
		TheMask,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			showExclusionAlert: false,
			mensagemErro: '',
			headersSelecionados: [
				'extr_is_bloqueado',
				'extr_tx_funcao',
				'extr_tx_telefone',
				'extr_nm_nome',
				'extr_cd_codigo',
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				extr_cd_codigo: '',
				extr_nm_nome: '',
				extr_tx_telefone: '',
				extr_tx_funcao: '',
				extr_is_bloqueado: false,
				extr_tx_senha_app: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				tags: {
					extr_is_bloqueado: classesParaUsuariosBloqueados,
				},
				statusTable: this.$t('loading') + '...',
				prefix: 'EX',
				subtitleCardPropertie: 'extr_cd_codigo',
				titleCardPropertie: 'extr_nm_nome',
			},
			tableHeaders: [
				{ key: 'extr_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'extr_nm_nome', value: this.$t('name'), isActive: true },
				{ key: 'extr_tx_telefone', value: this.$t('phone'), isActive: true },
				{ key: 'extr_tx_funcao', value: this.$t('function'), isActive: true },
				{
					key: 'extr_is_bloqueado',
					value: this.$t('blocked'),
					isActive: true,
				},
			],
		}
	},

	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.extr_nm_nome && this.model.extr_tx_senha_app
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['extr_cd_codigo']
		getAllExecutores().then((response) => {
			const { result: executores } = response.data
			executores.forEach((executor) => this.formataExecutoresParaCrud(executor))
			this.modelList = executores
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Abrevia os campos de usuário
		 */
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		abreviarCampos() {
			this.model.extr_is_bloqueado = abreviar[this.model.extr_is_bloqueado]
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createExecutorToPost() {
			return {
				id: uuidv4(),
				extr_nm_nome: this.model.extr_nm_nome,
				extr_tx_telefone: this.model.extr_tx_telefone,
				extr_tx_funcao: this.model.extr_tx_funcao,
				extr_is_bloqueado: this.model.extr_is_bloqueado,
				extr_tx_senha_app: this.model.extr_tx_senha_app,
			}
		},

		/**
		 * Cria novo Executor no banco de dados
		 */
		create() {
			const executor = this.createExecutorToPost()

			createExecutor(executor).then((response) => {
				const { result: executor, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.cleanModel()
					this.formataExecutoresParaCrud(executor)
					this.modelList.unshift(executor)

					this.showForm = false
					this.emptyValue = ''

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Atualiza Executor no banco de dados
		 */
		update() {
			updateExecutor(this.model).then((response) => {
				const { result: executor, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataExecutoresParaCrud(executor)

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexModel, executor)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui executor no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(executor) =>
						this.modelsIdWithCheckedToDelete.includes(executor.id) &&
						executor.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteExecutorByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var executoresOrganizados = existeRegistroComDependencia
						.map((executor) => `• CO-${executor.extr_cd_codigo} -  ${executor.extr_nm_nome}`)
						.join('<br/>')
					var message = `<b>${this.$t('registroDeTrabalhoExecutado')}:</b> <br/><br/> ${executoresOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Formata executor para tabela e crud
		 */
		formataExecutoresParaCrud(executor) {
			executor.isCheckedToDelete = false

			executor.extr_is_bloqueado = desabreviar[executor.extr_is_bloqueado]
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.abreviarCampos()

			this.titleForm = `${this.$t('edit')} ${this.$t('collector')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('collector')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},

		validaPassword() {
			// Verificar se o password contém letras
			if (isNaN(this.model.extr_tx_senha_app)) {
				this.mensagemErro = 'Por favor, digite apenas números.'
				this.disableSaveButton = true
			} else {
				this.mensagemErro = ''
				this.disableSaveButton = false
			}
			if (this.model.extr_tx_senha_app.length > 4) {
				this.mensagemErro = 'A senha  deve conter exatamente 4 dígitos.'
			}
		},

		/**
		 * Baixa o CSV com dados de coletor
		 */
		downloadCSVColetor() {
			let cabecalhoDoCsvColetor = ['Código', 'Nome', 'Telefone', 'Função', 'Bloqueado']
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvColetor,
				...items.map((item) => [
					item.extr_cd_codigo,
					item.extr_nm_nome,
					item.extr_tx_telefone,
					item.extr_tx_funcao,
					item.extr_is_bloqueado,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_coletor.csv', 'text/csv')
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
